import { Outlet } from "react-router-dom"
import styled from "styled-components"

import { useAppSelector } from "store/hooks"
import { contractorThemeSelector } from "store/tempDataSlise"
import logo from "assets/svg/logo-white.svg"

import backgroundLogo from "../../assets/img/backgound-logo.png"

import styles from "./index.module.scss"

const StyledSection = styled.section<{ backgroundStyle: string }>`
  background: ${({ backgroundStyle }) => `url(${backgroundLogo}), ${backgroundStyle}`};
`

export const AuthLayout = () => {
  const currentTheme = useAppSelector(contractorThemeSelector)

  const getBackgroundStyle = () => {
    return currentTheme.backgroundGradient
  }

  return (
    <StyledSection backgroundStyle={getBackgroundStyle()} className={styles.authWrapper}>
      <Outlet />
      <figure className={styles.logoWrapper}>
        <img className={styles.logo} src={logo} alt="logo" />
      </figure>
    </StyledSection>
  )
}
